// Homepage — bootstrap. Each slice section renders a host
//   <div class="cravy-site cravy-home" data-slice="KEY" style="--k:1">
//     <script type="application/json" class="cravy-cfg">{ ...settings... }</script>
//     <div class="cravy-mount"></div>
//   </div>
// This finds every host, reads its config, and mounts the matching component.
// Re-mounts live on Shopify theme-editor events so edits preview instantly.
(function () {
  function reg() {
    return window.CravyHome || {};
  }
  function mountOne(host) {
    var key = host.getAttribute('data-slice');
    var Comp = reg()[key];
    var mountEl = host.querySelector('.cravy-mount');
    if (!Comp || !mountEl) return;
    var cfg = {};
    var cfgEl = host.querySelector('script.cravy-cfg');
    if (cfgEl) {
      try {
        cfg = JSON.parse(cfgEl.textContent || '{}');
      } catch (e) {
        cfg = {};
      }
    }
    if (host.__cravyRoot) {
      try {
        host.__cravyRoot.unmount();
      } catch (e) {}
      host.__cravyRoot = null;
    }
    var root = ReactDOM.createRoot(mountEl);
    root.render(React.createElement(Comp, {
      cfg: cfg
    }));
    host.__cravyRoot = root;
  }
  function mountAll(scope) {
    var hosts = (scope || document).querySelectorAll('.cravy-home[data-slice]');
    for (var i = 0; i < hosts.length; i++) mountOne(hosts[i]);
  }
  function unmountAll(scope) {
    var hosts = (scope || document).querySelectorAll('.cravy-home[data-slice]');
    for (var i = 0; i < hosts.length; i++) {
      var h = hosts[i];
      if (h.__cravyRoot) {
        try {
          h.__cravyRoot.unmount();
        } catch (e) {}
        h.__cravyRoot = null;
      }
    }
  }
  function boot() {
    if (!window.React || !window.ReactDOM || !ReactDOM.createRoot) {
      setTimeout(boot, 40);
      return;
    }
    mountAll(document);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) {
    mountAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    unmountAll(e.target);
  });
})();
